export type StorageMode = "auto" | "indexeddb" | "localstorage";
export type ActiveStorageEngine = "indexeddb" | "localstorage";

const STORAGE_MODE_KEY = "cronicas-arton:storage-mode";

export function getStorageMode(): StorageMode {
  if (typeof window === "undefined") {
    return "auto";
  }

  const value = window.localStorage.getItem(STORAGE_MODE_KEY);
  if (value === "indexeddb" || value === "localstorage" || value === "auto") {
    return value;
  }

  return "auto";
}

export function setStorageMode(mode: StorageMode) {
  window.localStorage.setItem(STORAGE_MODE_KEY, mode);
}
